module.exports = __webpack_public_path__ + "media/images/illustrations/designer-life-25784bdb1c221e1c7b583c2d5c368cd9.svg";